import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IActualite, setFilteredActualites } from "../../store/siteWebSlice";
import { IParentStudentItem, setStudents, setdataFiltered } from "../../store/focusEcoleSlice";

export interface ISearchProps {
  search: any;
  setSearch: any;
}


const SearchBar = (props: ISearchProps) => {
  const { search, setSearch } = props
  const dispatch = useDispatch();
  const { students, dataFiltered } = useSelector((state: IReduxState) => state.focusEcole);


  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));
  // const [search, setSearch] = React.useState("");


  /*
  const filterFunction = () => {
    if (search.length === 0) {
      dispatch(setdataFiltered([...students]));
    } else {
      const result: any = students.filter(
        (item: IParentStudentItem, index: number) => {
          const value: any = `${item.nomEleve} ${item.prenomEleve} ${item.codeEtab} ${item.libEtab} ${item.numeroCellulaire}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setdataFiltered(result));
    }
  };

  React.useEffect(() => {
    filterFunction();
  }, [search]);
*/


  return (
    <Box>
      <TextField
        style={{ marginTop: endesssousDeLg ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
